import React, { useEffect, useRef, useState } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";
import { MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowUp } from "react-icons/md";
import "./Navigation.css";
// import logo from "../../assets/images/Logo-white.png";
import { IoMenuOutline } from "react-icons/io5";

function Navigation() {

  const [expanded, setExpanded] = useState(false);
  const [showPolicies, setShowPolicies] = useState(false);
  const [showIsoCert, setShowIsoCert] = useState(false);
  const dropdownRef = useRef(null);
  // const [showPolicies, setShowPolicies] = useState(false);
  const [reportsOpen, setReportsOpen] = useState(false)


  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0 && expanded) {
        setExpanded(true);
      }

      if (expanded) {
        setExpanded(false);
      }
    }

    if (expanded) {
      window.addEventListener('scroll', handleScroll);
    }
    window.scrollTo(0, 0);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    }

  }, [expanded]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setReportsOpen(false);
        setShowPolicies(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const handleClick = () => {
    setExpanded(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleToggle = () => {
    if (window.scrollY > 0) {

      setExpanded(true)
      setTimeout(() => {
        setExpanded(true);
      }, 800);
    }
    else {
      setExpanded(!expanded)
    }
  }


  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      className="text-white bg-white p-1 shadow px-1"
      id="rescstomcss_1"
      expanded={expanded}
      style={{ background: "#0000" }}
    >
      <div className="logo-container">
        <Link to="/">
          <img
            className="logo-image p-1"
            src="/gautamsolarLogo.webp"
            width={150}
            height={51}
            alt="Gautam Solar Logo"
            style={{ background: "#a20000", borderRadius: "16px" }}
          />
        </Link>
      </div>

      <button aria-label="menu" onClick={handleToggle} className="d-block d-lg-none border rounded p-1">
        <IoMenuOutline size={30} />
      </button>

      <Navbar.Collapse id="responsive-navbar-nav" className="mt-2 custom-border-top">
        <Nav
          className="me-auto navigation d-flex align-items-center align-items-custom"
          id="navbartop"
          style={{ fontSize: "18px", width: "100%" }}
        >
          <Link to="/" onClick={handleClick} className="nav-link" style={{ fontSize: "15px" }}>
            Home
          </Link>
          <Link to="/aboutus" onClick={handleClick} className="nav-link" style={{ fontSize: "15px" }}>
            About Us
          </Link>

          <Link to="/inverter" onClick={handleClick} className="nav-link" style={{ fontSize: "15px" }}>
            Inverter
          </Link>
          <Link to="/bess" onClick={handleClick} className="nav-link" style={{ fontSize: "15px" }}>
            Bess
          </Link>

          {/* Solar Modules Dropdown (unchanged) */}
          <div className="dropdown">
            <Link to="/blog#pricing" className="dropdown-link nav-link" style={{ fontSize: "15px" }}>
              Solar Modules <span><MdOutlineKeyboardArrowDown /></span>
            </Link>
            <div className="dropdown-content p-1 rounded">
              <div className="dropdown-item p-1 mb-2 border-bottom" style={{ whiteSpace: "pre-wrap" }}>
                <Link to="/topcon" onClick={handleClick} className="nav-link" style={{ fontSize: "14px" }}>
                  N-Type TOPCon Solar Modules
                </Link>
              </div>
              <div className="dropdown-item p-1 mb-2 border-bottom" style={{ whiteSpace: "pre-wrap", textAlign: "left" }}>
                <Link to="/mono" onClick={handleClick} className="nav-link" style={{ fontSize: "14px" }}>
                  Mono PERC Solar Modules
                </Link>
              </div>
            </div>
          </div>

          {/* Solar Power Plant Dropdown (unchanged) */}
          <div className="dropdown">
            <Link to="/blog#pricing" className="dropdown-link nav-link" style={{ fontSize: "15px" }}>
              Solar Power Plant <span><MdOutlineKeyboardArrowDown /></span>
            </Link>
            <div className="dropdown-content p-1 rounded">
              <div className="dropdown-item px-2 py-2 mb-2 border-bottom" style={{ whiteSpace: "pre-wrap" }}>
                <Link to="/solarplants" onClick={handleClick} className="nav-link" style={{ fontSize: "14px" }}>
                  Solar Power Plant
                </Link>
              </div>
              <div className="dropdown-item px-2 py-2 mb-2 border-bottom" style={{ whiteSpace: "pre-wrap", textAlign: "left" }}>
                <Link to="/kusum" onClick={handleClick} className="nav-link" style={{ fontSize: "14px" }}>
                  PM-Kusum-Yojna
                </Link>
              </div>
            </div>
          </div>

          <Link to="/blog" onClick={handleClick} className="nav-link" style={{ fontSize: "15px" }}>
            Blog
          </Link>
          <Link to="/contactus" onClick={handleClick} className="nav-link" style={{ fontSize: "15px" }}>
            Contact Us
          </Link>

          {/* ========== FIXED RESOURCES DROPDOWN with nested REPORTS ========== */}
          <div className="dropdown" ref={dropdownRef}>
            <Link to="/blog#pricing" className="dropdown-link nav-link" style={{ fontSize: "15px" }}>
              Resources <span><MdOutlineKeyboardArrowDown /></span>
            </Link>
            <div className="dropdown-content p-3 rounded" style={{ minWidth: "190px", position: "absolute", backgroundColor: "white", zIndex: 1000 }}>
              {/* Grid container – will be block on desktop, grid on mobile */}
              <div className="resources-grid">
                {/* ESG Compliance */}
                <div className="dropdown-item">
                  <Link to="/esg" onClick={handleClick} className="nav-link" style={{ fontSize: "13px" }}>
                    ESG Compliance
                  </Link>
                </div>

                {/* Quality Certificate */}
                <div className="dropdown-item">
                  <Link to="/quality" onClick={handleClick} className="nav-link" style={{ fontSize: "13px" }}>
                    Quality Certificate
                  </Link>
                </div>

                {/* Media */}
                <div className="dropdown-item">
                  <Link to="/media" onClick={handleClick} className="nav-link" style={{ fontSize: "14px" }}>
                    Media
                  </Link>
                </div>

                {/* CSR */}
                <div className="dropdown-item">
                  <Link to="/csr" onClick={handleClick} className="nav-link" style={{ fontSize: "13px" }}>
                    CSR
                  </Link>
                </div>

                {/* White Paper */}
                <div className="dropdown-item">
                  <Link to="/whitepaper" onClick={handleClick} className="nav-link" style={{ fontSize: "13px" }}>
                    White Paper
                  </Link>
                </div>

                {/* Reports button */}
                <div className="report-button-wrapper">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setReportsOpen(!reportsOpen);
                      setShowPolicies(false);
                    }}
                    style={{
                      width: "100%",
                      textAlign: "left",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "13px",
                      color: "#a20000",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "8px 12px",
                      fontWeight: 600
                    }}
                  >
                    Reports
                    <span>{reportsOpen ? <MdOutlineKeyboardArrowUp /> : <MdOutlineKeyboardArrowDown />}</span>
                  </button>
                </div>
              </div>

              {/* Expandable Reports content – shown below the grid */}
              {reportsOpen && (
                <div className="reports-expanded-content" style={{ height: '100px', overflow: 'auto', marginTop: "1rem", borderTop: "1px solid #eee", paddingTop: "1rem" }}>
                  {/* GSPL Policies section */}
                  <div>
                    <button
                      onClick={() => setShowPolicies(!showPolicies)}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        padding: "6px 0",
                        fontSize: "13px",
                      }}
                      className="nav-link"
                    >
                      <span style={{ color: "#a20000", fontWeight: 500 }}>GSPL Policies</span>
                      {showPolicies ? <MdOutlineKeyboardArrowUp /> : <MdOutlineKeyboardArrowDown />}
                    </button>

                    {showPolicies && (
                      <div className="policy-subitems" style={{ marginLeft: "1px", marginTop: "4px" }}>
                        <button className="nav-link border-bottom"
                          style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
                          onClick={() => window.open('/documents/Business_Integrity&Confidential_Information_Policy.pdf', '_blank')}>
                          Business Integrity & Confidential Information Policy
                        </button>

                        <button className="nav-link border-bottom"
                          style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
                          onClick={() => window.open('/documents/Environmental&Sustainability_Policy.pdf', '_blank')}>
                          Environmental & Sustainability Policy
                        </button>

                        <button className="nav-link border-bottom"
                          style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
                          onClick={() => window.open('/documents/Sustainable_Procurement_Policy.pdf', '_blank')}>
                          Sustainable Procurement Policy
                        </button>

                        <button className="nav-link border-bottom"
                          style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
                          onClick={() => window.open('/documents/Responsible_Workplace&Human_Rights_Policy.pdf', '_blank')}>
                          Responsible Workplace & Human Rights Policy
                        </button>


                        <button className="nav-link border-bottom"
                          style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
                          onClick={() => window.open('/documents/Living_Wage_Policy.pdf', '_blank')}>
                          Living Wage Policy
                        </button>

                        <button
                          className="nav-link border-bottom"
                          style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
                          onClick={() =>
                            window.open(
                              "/documents/Gautam_Solar_GHG_Emission_Report.pdf",
                              "_blank"
                            )
                          }
                        >
                          GHG Emission Report
                        </button>

                        <button
                          className="nav-link border-bottom"
                          style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
                          onClick={() =>
                            window.open(
                              "/documents/GAUTAM_SOLAR_ESG_KPI_ROADMAP_UPTO_FY_2030-31.pdf",
                              "_blank"
                            )
                          }
                        >
                          ESG KPI ROADMAP UPTO FY 2030-31
                        </button>


                        {/* <a
                          href="/documents/Business_Integrity&Confidential_Information_Policy.pdf"
                          download
                          onClick={handleClick}
                          rel="noopener noreferrer"
                          className="nav-link border-bottom"
                          style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
                        >
                          Business Integrity & Confidential Information Policy
                        </a> */}
                        {/* <a
                          href="/documents/Environmental&Sustainability_Policy.pdf"
                          download
                          rel="noopener noreferrer"
                          onClick={handleClick}
                          className="nav-link border-bottom"
                          style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
                        >
                          Environmental & Sustainability Policy
                        </a> */}
                        {/* <a
                          href="/documents/Sustainable_Procurement_Policy.pdf"
                          download
                          rel="noopener noreferrer"
                          onClick={handleClick}
                          className="nav-link border-bottom"
                          style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
                        >
                          Sustainable Procurement Policy
                        </a> */}
                        {/* <a
                          href="/documents/Responsible_Workplace&Human_Rights_Policy.pdf"
                          download
                          rel="noopener noreferrer"
                          onClick={handleClick}
                          className="nav-link border-bottom"
                          style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
                        >
                          Responsible Workplace & Human Rights Policy
                        </a> */}
                        {/* <a
                          href="/documents/Living_Wage_Policy.pdf"
                          download
                          rel="noopener noreferrer"
                          onClick={handleClick}
                          className="nav-link"
                          style={{ display: "block", padding: "6px 12px", fontSize: "13px" }}
                        >
                          Living Wage Policy
                        </a> */}
                      </div>
                    )}
                  </div>

                  {/* GHG Report */}
                  {/* ESG Roadmap */}
                  {/* <div style={{ marginTop: "12px" }}>
                    <a
                      href="/documents/Gautam_Solar_GHG_Emission_Report.pdf"
                      download
                      rel="noopener noreferrer"
                      onClick={handleClick}
                      className="nav-link"
                      style={{ display: "block", fontSize: "13px", padding: "8px 0" }}
                    >
                      GHG Emission Report
                    </a>
                  </div>

                  <div>
                    <a
                      href="/documents/GAUTAM_SOLAR_ESG_KPI_ROADMAP_UPTO_FY_2030-31.pdf"
                      download
                      rel="noopener noreferrer"
                      onClick={handleClick}
                      className="nav-link"
                      style={{ display: "block", fontSize: "13px", padding: "8px 0" }}
                    >
                      ESG KPI ROADMAP UPTO FY 2030-31
                    </a>
                  </div> */}
                  {/* 
                  <div style={{ marginTop: "12px" }}>
                    <button
                      className="nav-link border-bottom"
                      style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
                      onClick={() =>
                        window.open(
                          "/documents/Gautam_Solar_GHG_Emission_Report.pdf",
                          "_blank"
                        )
                      }
                    >
                      GHG Emission Report
                    </button>
                  </div> */}

                  {/* ESG Roadmap */}
                  {/* <div>
                    <button
                      className="nav-link border-bottom"
                      style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
                      onClick={() =>
                        window.open(
                          "/documents/GAUTAM_SOLAR_ESG_KPI_ROADMAP_UPTO_FY_2030-31.pdf",
                          "_blank"
                        )
                      }
                    >
                      ESG KPI ROADMAP UPTO FY 2030-31
                    </button>
                  </div> */}


                  <div>
                    <button
                      onClick={() => setShowIsoCert(!showIsoCert)}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        padding: "6px 0",
                        fontSize: "13px",
                      }}
                      className="nav-link"
                    >
                      <span style={{ color: "#a20000", fontWeight: 500 }}>ISO Certificates</span>
                      {showIsoCert ? <MdOutlineKeyboardArrowUp /> : <MdOutlineKeyboardArrowDown />}
                    </button>

                    {showIsoCert && (

                      <div
                        className="policy-subitems"
                        style={{ marginLeft: "12px", marginTop: "4px" }}
                      >
                        <div>
                          <button
                            className="nav-link border-bottom"
                            style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
                            onClick={() => window.open("/documents/GSPL_9001.pdf", "_blank")}
                          >
                            ISO-9001
                          </button>
                        </div>

                        <div>
                          <button
                            className="nav-link border-bottom"
                            style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
                            onClick={() => window.open("/documents/GSPL_14001.pdf", "_blank")}
                          >
                            ISO-14001
                          </button>
                        </div>

                        <div>
                          <button
                            className="nav-link border-bottom"
                            style={{ display: "block", padding: "6px 12px", fontSize: "12px" }}
                            onClick={() => window.open("/documents/GSPL_45001.pdf", "_blank")}
                          >
                            ISO-45001
                          </button>
                        </div>
                      </div>
                      // <div className="policy-subitems" style={{ marginLeft: "12px", marginTop: "4px" }}>
                      //   <div>
                      //     <a
                      //       href="/documents/GSPL_9001.pdf"
                      //       download
                      //       rel="noopener noreferrer"
                      //       onClick={handleClick}
                      //       className="nav-link"
                      //       style={{ display: "block", fontSize: "13px", padding: "8px 0" }}
                      //     >
                      //       ISO-9001
                      //     </a>
                      //   </div>

                      //   <div>
                      //     <a
                      //       href="/documents/GSPL_14001.pdf"
                      //       download
                      //       rel="noopener noreferrer"
                      //       onClick={handleClick}
                      //       className="nav-link"
                      //       style={{ display: "block", fontSize: "13px", padding: "8px 0" }}
                      //     >
                      //       ISO-14001
                      //     </a>
                      //   </div>

                      //   <div>
                      //     <a
                      //       href="/documents/GSPL_45001.pdf"
                      //       download
                      //       rel="noopener noreferrer"
                      //       onClick={handleClick}
                      //       className="nav-link"
                      //       style={{ display: "block", fontSize: "13px", padding: "8px 0" }}
                      //     >
                      //       ISO-45001
                      //     </a>
                      //   </div>

                      // </div>
                    )}
                  </div>
                  {/* ISO Documents */}
                </div>
              )}
            </div>
          </div>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default Navigation;
